export default __webpack_public_path__ + "static/media/school.0253f079.png";